module.exports = __webpack_public_path__ + "img/gift4-01-c03-k2.9fb25c85.png";